import { textAndImageBlock as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';
import { WideProps } from '.';

const TestData: WideProps = {
  eyebrow: 'Careers',
  header: 'We open doors and close deals.',
  imgFocalPoint: {
    image: '/assets/textimageplaceholder.png',
  },
};

export default fakeProps(schema, TestData);
